jQuery(document).ready(function($) {

    const modules = import.meta.glob('./classes/**/*.js');

    // Resolves once every class instantiated during initial page load has
    // finished its dynamic import. Tools that need to broadcast events to
    // sibling listeners (e.g. syncOldData replaying a saved selection) can
    // await this instead of guessing with setTimeout — under Vite the import
    // order has no guarantee, so a fixed delay can race a slow chunk.
    let resolveAllClassesLoaded;
    window.__appClassesLoaded = new Promise((resolve) => {
        resolveAllClassesLoaded = resolve;
    });

    function init(){
        loadClasses(true);
    }

    //listen for manual trigger to init new classes on newly added DOM element.
    document.addEventListener("initClasses", function(event) {
        loadClasses(false);
    });

    function loadClasses(isInitial){
        // We get all the elements into the DOM with a JS class linked
        const $elementsWithClass = $('[data-class]:not([data-class-loaded="true"])');

        // We get unique classes to import based on all the elements into the DOM with a JS class linked
        let classesToLoad = [];
        $.each($elementsWithClass, (index, element) => {
            const relatedClass = element.dataset.class;
            if (classesToLoad.includes(relatedClass)) { return; }
            classesToLoad.push(relatedClass);
        });

        // We are going to load the required classes
        const loadPromises = [];
        $.each(classesToLoad, (index, className) => {
            const modulePath = `./classes/${className}.js`;
            const loader = modules[modulePath];

            if (!loader) {
                console.error(className + ' : Module not found at ' + modulePath);
                return;
            }

            // Let's import the class file
            const promise = loader().then((module) => {
                // When the class is imported, we initialize the class for each DOM element linked to the class
                $.each($elementsWithClass.filter('[data-class="' + className + '"]'), (index, element) => {
                    const $element = $(element);
                    const classNameParts = className.split('/');
                    const instance = new module[classNameParts[classNameParts.length -1]](element);
                    $element.attr('data-class-loaded', 'true');
                });
            }).catch(error => {
                console.error(className + ' : ' + error.toString());
            });
            loadPromises.push(promise);
        });

        if (isInitial) {
            Promise.all(loadPromises).then(() => resolveAllClassesLoaded());
        }
    }

    init();
});
